import { jsxs as b, jsx as g } from "react/jsx-runtime";
import n, { useEffect as B } from "react";
import G, { css as c } from "styled-components";
import { RangoButton as R } from "./Button.js";
import { RangoButtonMini as S } from "./ButtonMini.js";
const f = {
  LG: "lg",
  SM: "sm"
};
Object.values(f);
const o = {
  Horizontal: "horizontal",
  Vertical: "vertical"
};
Object.values(o);
const h = G.div.withConfig({
  displayName: "ButtonGroup",
  componentId: "sc-4fu04b-0"
})(["display:flex;align-items:center;justify-content:center;", ";", ";"], ({
  orientation: t
}) => t === o.Vertical && c(["flex-direction:column;"]), ({
  orientation: t
}) => t === o.Horizontal ? c(["display:inline-flex;gap:var(--spacing-4x);"]) : c(["gap:var(--spacing-2x);"])), x = n.forwardRef(({
  children: t,
  size: a = f.LG,
  orientation: r = o.Horizontal,
  ...s
}, u) => {
  const [l, i] = n.useState(t), d = () => n.Children.map(t, (e) => n.cloneElement(e, {
    ...e.props,
    buttonProps: {
      size: a,
      blocked: r === o.Vertical
    }
  }));
  B(() => {
    i(d());
  }, [a, r, t]);
  const m = (e) => n.Children.toArray(l).filter((p) => p.props.slot === e);
  return (() => {
    const e = r === o.Vertical ? "primary" : "secondary", p = r === o.Vertical ? "secondary" : "primary";
    return /* @__PURE__ */ b(h, { size: a, orientation: r, "data-rango-component": "rango-button-group", "data-is-rango": !0, ...s, ref: u, "data-testid": "rango-button-group", children: [
      m(e),
      m(p)
    ] });
  })();
});
x.displayName = "RangoButtonGroup";
const y = {
  Mini: "mini",
  Primary: "primary"
};
Object.values(y);
const C = n.forwardRef(({
  children: t,
  onClick: a,
  variant: r = y.Primary,
  ...s
}, u) => (() => {
  const i = {
    ...s,
    onClick: a,
    children: t
  };
  return delete i.buttonProps, {
    primary: /* @__PURE__ */ g(R, { "data-testid": "rango-button-group-item-primary", ...i, ref: u }),
    mini: /* @__PURE__ */ g(S, { "data-testid": "rango-button-group-item-mini", ...i, ref: u })
  }[r];
})());
C.displayName = "RangoButtonGroupItem";
export {
  y as ButtonGroupItemVariant,
  o as ButtonGroupOrientation,
  f as ButtonGroupSize,
  x as RangoButtonGroup,
  C as RangoButtonGroupItem
};
